import React from 'react';
import FormObjectDropdown from './FormObjectDropdown';
import FormObjectInformationHeaderContainer from './FormObjectInformationHeaderContainer';

const FormObjectInformationHeader = ({
  activeIndex,
  allowAdd,
  allowRemove,
  canEdit,
  changeItem,
  deleteItem,
  entity,
  errors,
  field,
  insertItem,
  items,
  textField,
}) => (
  <FormObjectInformationHeaderContainer
    allowAdd={allowAdd}
    allowRemove={allowRemove}
    canEdit={canEdit}
    deleteItem={deleteItem}
    entity={entity}
    field={field}
    insertItem={insertItem}
    items={items}
    textField={textField}
  >
    <FormObjectDropdown
      activeIndex={activeIndex}
      className="aridhia-form-object-changer mr-20"
      errors={errors.map((error) => error.context.entity)}
      inline
      items={items}
      onChange={changeItem}
      textField={textField}
    />
  </FormObjectInformationHeaderContainer>
);

export default FormObjectInformationHeader;
